import client from "~/apis/client"

export function createMessageLog({ bookingId, kind, phone, body }) {
  return client.post("/message_logs", { booking_id: bookingId, kind, phone, body })
}
